import type {StackProps} from '@travel-frontend/ui-components';

import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const BadgesWrapper = styled(
  ({children, ...restProps}: React.PropsWithChildren<StackProps>) => (
    <Stack {...restProps} direction="row">
      {children}
    </Stack>
  )
)`
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 4px;

  &:empty {
    display: none;
  }
`;
